import React, { useEffect, useRef, useState } from 'react';
import styles from './WhatWeDo.module.css';
import banner from '../assets/WhatWeDoPageAssets/1x/Asset 19@2x.png';

import birdLeft from '../assets/WhatWeDoPageAssets/1x/Asset 49@2x.png';
import storysnap1 from '../assets/WhatWeDoPageAssets/Snippets/Storysnap.jpg';
import storysnap2 from '../assets/WhatWeDoPageAssets/Snippets/Storysnap2.jpg';

import birdCenter from '../assets/WhatWeDoPageAssets/1x/Asset 48@2x.png';
import interactivesnap1 from '../assets/WhatWeDoPageAssets/Snippets/Interactivessnap.jpg'
import interactivesnap2 from '../assets/WhatWeDoPageAssets/Snippets/Interactivessnap2.jpg'

import birdRight from '../assets/WhatWeDoPageAssets/1x/Asset 47@2x.png';
import jinglesnap1 from '../assets/WhatWeDoPageAssets/Snippets/jinglesnap.jpg'
import jinglesnap2 from '../assets/WhatWeDoPageAssets/Snippets/jinglesnap2.jpg'

import hipo from '../assets/WhatWeDoPageAssets/1x/hippo.png';
import hipophone from '../assets/WhatWeDoPageAssets/1x/Asset 55@2x.png';

import cow from '../assets/WhatWeDoPageAssets/1x/cow.png';
import cowphone from '../assets/WhatWeDoPageAssets/1x/Asset 54@2x.png';
import { Helmet } from "react-helmet-async";

import elephant from '../assets/WhatWeDoPageAssets/1x/elephant.png';
import elephantphone from '../assets/WhatWeDoPageAssets/1x/Asset 53@2x.png';

import oak from '../assets/WhatWeDoPageAssets/1x/oak.png';
import activitycard from '../assets/WhatWeDoPageAssets/1x/activity_card.png';
import info from '../assets/WhatWeDoPageAssets/1x/infoB.png';
import info1 from '../assets/WhatWeDoPageAssets/1x/Asset 20@2x.png';
import sourceBanner1 from '../assets/WhatWeDoPageAssets/1x/Asset 33@2x.png';
import sourceBanner2 from '../assets/WhatWeDoPageAssets/1x/Asset 33@2x.png';
import sourceBanner3 from '../assets/WhatWeDoPageAssets/1x/Asset 33@2x.png';
import sourceBanner4 from '../assets/WhatWeDoPageAssets/1x/Asset 33@2x.png';
import sourceBanner5 from '../assets/WhatWeDoPageAssets/1x/Asset 38@2x.png';
import sourceBanner6 from '../assets/WhatWeDoPageAssets/1x/Asset 38@2x.png';
import sourceBanner7 from '../assets/WhatWeDoPageAssets/1x/Asset 38@2x.png';
import sourceBanner8 from '../assets/WhatWeDoPageAssets/1x/Asset 32@2x.png';
import sourceBanner9 from '../assets/WhatWeDoPageAssets/1x/Asset 38@2x.png';
import sourceBanner10 from '../assets/WhatWeDoPageAssets/1x/Asset 38@2x.png';
import sourceBanner11 from '../assets/WhatWeDoPageAssets/1x/Asset 38@2x.png';
import activity1 from '../assets/Whatwedopageupdatedassests/kidscard.png';
import activity2 from '../assets/Whatwedopageupdatedassests/teacherscard.png';
import activity3 from '../assets/Whatwedopageupdatedassests/parents.png';

import Mobileactivity1 from '../assets/Whatwedopageupdatedassests/mobileactivity1.png';
import Mobileactivity2 from '../assets/Whatwedopageupdatedassests/mobileactivity2.png';
import Mobileactivity3 from '../assets/Whatwedopageupdatedassests/mobileactivity3.png';
import elephantcrew from '../assets/WhatWeDoPageAssets/1x/elephantcrew.png'
import chess from '../assets/WhatWeDoPageAssets/1x/chess.png'
import dogs from '../assets/WhatWeDoPageAssets/1x/dogs.png'
import infoboard from '../assets/WhatWeDoPageAssets/1x/Asset 19@2x.png'
import kids1 from '../assets/Whatwedopageupdatedassests/Kids_1.png'
import kids2 from '../assets/Whatwedopageupdatedassests/Kids_2.png'
import teacher_1 from '../assets/Whatwedopageupdatedassests/Teacher_1.png'
import teacher_2 from '../assets/Whatwedopageupdatedassests/Teacher_2.png'
import parent1 from '../assets/Whatwedopageupdatedassests/Parents_1.png'
import parent2 from '../assets/Whatwedopageupdatedassests/Parents_2.png'
import { useNavigate } from 'react-router-dom';

import mobileboard from '../assets/webp/aboutUs.webp';

import cloude1 from '../assets/WhatWeDoPageAssets/1x/Asset 56@2x.png';
import cloude2 from '../assets/WhatWeDoPageAssets/1x/Asset 57@2x.png';
import cloude3 from '../assets/WhatWeDoPageAssets/1x/Asset 58@2x.png';





// Image to display in modal when info icons are clicked
const youtubeLinks = {
    story: {
        front: 'https://www.youtube.com/watch?v=jc0A01yUI_w',
        back: 'https://www.youtube.com/watch?v=jc0A01yUI_w'
    },
    jingle: {
        front: 'https://www.youtube.com/watch?v=Q6yjJSgdXXg',
        back: 'https://www.youtube.com/watch?v=Q6yjJSgdXXg'
    },
    interactive: {
        front: 'https://www.youtube.com/watch?v=bzwr7XLnFhs',
        back: 'https://www.youtube.com/watch?v=bzwr7XLnFhs'
    }
    // kids: {
    //     front: 'https://www.youtube.com/watch?v=YOUR_KIDS_FRONT_VIDEO_ID',
    //     back: 'https://www.youtube.com/watch?v=YOUR_KIDS_BACK_VIDEO_ID'
    // },
    // teacher: {
    //     front: 'https://www.youtube.com/watch?v=YOUR_TEACHER_FRONT_VIDEO_ID',
    //     back: 'https://www.youtube.com/watch?v=YOUR_TEACHER_BACK_VIDEO_ID'
    // },
    // parent: {
    //     front: 'https://www.youtube.com/watch?v=YOUR_PARENT_FRONT_VIDEO_ID',
    //     back: 'https://www.youtube.com/watch?v=YOUR_PARENT_BACK_VIDEO_ID'
    // }
};

function Whatwedo() {
    const [popover, setPopover] = useState({ open: false, img: null, imgs: null, top: 0, left: 0, centered: false, linkType: null });
    const [flipIndex, setFlipIndex] = useState(0);
    const [isFlipped, setIsFlipped] = useState(false);
    const anchorRef = useRef(null);
    const info1Ref = useRef(null);
    const info2Ref = useRef(null);
    const info3Ref = useRef(null);
    const info4Ref = useRef(null);
    const info5Ref = useRef(null);
    const info6Ref = useRef(null);
    const info7Ref = useRef(null);
    const info8Ref = useRef(null);
    const info9Ref = useRef(null);
    const info10Ref = useRef(null);
    const info10MobileRef = useRef(null);
    const info11MobileRef = useRef(null);
    const info11Ref = useRef(null);
    const navigate = useNavigate()

    const openPopover = (evt, img) => {
        const rect = evt.currentTarget.getBoundingClientRect();
        const gap = 12;
        const assumedMaxWidth = 360;
        const left = Math.min(rect.right + gap, window.innerWidth - assumedMaxWidth - 8);
        const top = rect.top + rect.height / 2;
        setPopover({ open: true, img, top, left, centered: false, imgs: null, linkType: null });
    };

    const closePopover = () => {
        setPopover({ open: false, img: null, imgs: null, top: 0, left: 0, centered: false, linkType: null });
        setIsFlipped(false);
    };

    const togglePopover = (evt, img) => {
        if (popover.open && anchorRef.current === evt.currentTarget) {
            closePopover();
            return;
        }
        anchorRef.current = evt.currentTarget;
        openPopover(evt, img);
    };

    // Centered group for flip cards (activity cards)
    const openCenteredGroup = (evt, imgs, linkType) => {
        setPopover({
            open: true,
            img: null,
            imgs,
            top: 0,
            left: 0,
            centered: true,
            linkType: linkType
        });
        setFlipIndex(0);
        setIsFlipped(false);
        anchorRef.current = evt.currentTarget;
    };

    const toggleCenteredGroup = (evt, imgs, linkType) => {
        if (popover.open && popover.centered) {
            if (anchorRef.current === evt.currentTarget) {
                closePopover();
                return;
            }
        }
        openCenteredGroup(evt, imgs, linkType);
    };

    const handleFlip = (e) => {
        e.stopPropagation();
        if (!Array.isArray(popover.imgs) || popover.imgs.length < 2) return;
        setIsFlipped(f => !f);
        setFlipIndex(i => (i === 0 ? 1 : 0));
    };

    const handleImageClick = (e, side) => {
        e.stopPropagation();
        if (popover.linkType && youtubeLinks[popover.linkType]) {
            const link = side === 'front' ? youtubeLinks[popover.linkType].front : youtubeLinks[popover.linkType].back;
            window.open(link, '_blank', 'noopener,noreferrer');
        }
    };

    useEffect(() => {
        if (!popover.open) return;
        const onKey = (e) => { if (e.key === 'Escape') closePopover(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [popover.open]);

    useEffect(() => {
        if (!popover.open || popover.centered) return;
        const rePos = () => {
            if (!anchorRef.current) return;
            const rect = anchorRef.current.getBoundingClientRect();
            const gap = 12;
            const assumedMaxWidth = 360;
            const left = Math.min(rect.right + gap, window.innerWidth - assumedMaxWidth - 8);
            const top = rect.top + rect.height / 2;
            setPopover(p => ({ ...p, top, left }));
        };
        window.addEventListener('scroll', rePos, { passive: true, capture: true });
        window.addEventListener('resize', rePos, { passive: true });
        rePos();
        return () => {
            window.removeEventListener('scroll', rePos, true);
            window.removeEventListener('resize', rePos);
        };
    }, [popover.open, popover.centered]);

    return (
        <>
           <Helmet>
  <title>
    What We Do | Jungle Morals
  </title>

  <meta
    name="description"
    content="Jungle Morals creates fun stories, videos, and activities that help kids build emotional intelligence, strong values, and real-life skills."
  />

  <meta name="robots" content="index, follow" />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/whatwedo"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="What We Do | Jungle Morals"
  />

  <meta
    property="og:description"
    content="Jungle Morals creates fun stories, videos, and activities that help kids build emotional intelligence, strong values, and real-life skills."
  />

  <meta
    property="og:url"
    content="https://www.junglemorals.com/whatwedo"
  />

  <meta property="og:type" content="website" />

  <meta
    property="og:image"
    content="https://www.junglemorals.com/static/media/what-we-do-banner.webp"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="What We Do | Jungle Morals"
  />

  <meta
    name="twitter:description"
    content="Jungle Morals creates fun stories, videos, and activities that help kids build emotional intelligence, strong values, and real-life skills."
  />

  <meta
    name="twitter:image"
    content="https://www.junglemorals.com/static/media/what-we-do-banner.webp"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.junglemorals.com/#organization",
          name: "Jungle Morals",
          url: "https://www.junglemorals.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/logo.webp"
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://www.junglemorals.com/#website",
          url: "https://www.junglemorals.com/",
          name: "Jungle Morals",
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          }
        },
        {
          "@type": "WebPage",
          "@id": "https://www.junglemorals.com/whatwedo#webpage",
          url: "https://www.junglemorals.com/whatwedo",
          name: "What We Do | Jungle Morals",
          description:
            "Jungle Morals creates fun stories, videos, and activities that help kids build emotional intelligence, strong values, and real-life skills.",
          inLanguage: "en",
          isPartOf: {
            "@id": "https://www.junglemorals.com/#website"
          },
          breadcrumb: {
            "@id": "https://www.junglemorals.com/whatwedo#breadcrumb"
          },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/what-we-do-banner.webp"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.junglemorals.com/whatwedo#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.junglemorals.com/"
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "What We Do",
              item: "https://www.junglemorals.com/whatwedo"
            }
          ]
        },
        {
          "@type": "CollectionPage",
          "@id": "https://www.junglemorals.com/whatwedo#collection",
          name: "What We Do",
          description:
            "Stories, videos, songs, and activities designed to help children learn emotional intelligence and positive values."
        }
      ]
    })}
  </script>
</Helmet>
            {/* <Navbar /> */}

            <section className={styles.wrapper}>
                <header className={styles.header}>
                    <img src={banner} alt="Entertainment with a Heartbeat" className={styles.banner} />
                    <h1 className={`font-adventuring ${styles.title}`}>Entertainment with a heartbeat</h1>
                </header> 

                <div className={styles.cardsRow}>
                    <div className={styles.card}>
                        <div className={styles.birdWrap}>
                            <img src={birdLeft}
                                alt="Cute cartoon animals celebrating Christmas with gifts and decorated tree in a kids classroom scene with bird mascot on top"
                                className={styles.bird1}
                                role='button'
                                tabIndex={0}
                                onClick={(e) => toggleCenteredGroup(e, [storysnap1, storysnap2], 'story')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [storysnap1, storysnap2], 'story'); } }}
                            />
                            <h3 className={`font-adventuring ${styles.title1}`}>Stories</h3>
                        </div>
                        <img src={cloude1} alt="" className={styles.cloude1} />
                        <img src={cloude1} alt="" className={styles.cloude1a} />


                    </div>

                    <div className={styles.card}>
                        <div className={styles.birdWrap}>
                            <img src={birdCenter}
                                alt="Cute cartoon animal friends dancing together in outdoor scene with crowned bird mascot above signboard"
                                className={styles.bird2}
                                role='button'
                                tabIndex={0}
                                onClick={(e) => toggleCenteredGroup(e, [jinglesnap1, jinglesnap2], 'jingle')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [jinglesnap1, jinglesnap2], 'jingle'); } }}
                            />
                            <h3 className={`font-adventuring ${styles.title2}`}>Jingles</h3>
                        </div>
                        <img src={cloude2} alt="" className={styles.cloude2} />
                        <img src={cloude2} alt="" className={styles.cloude2a} />

                    </div>

                    <div className={styles.card}>
                        <div className={styles.birdWrap}>
                            <img src={birdRight}
                                alt="Kids cartoon learning scene with animals and ‘who wants to be the smartest’ title and bird teacher character above signboard"
                                className={styles.bird3}
                                role='button'
                                tabIndex={0}
                                onClick={(e) => toggleCenteredGroup(e, [interactivesnap1, interactivesnap2], 'interactive')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [interactivesnap1, interactivesnap2], 'interactive'); } }}
                            />
                            <h3 className={`font-adventuring ${styles.title3}`}>Interactives</h3>
                        </div>
                        <img src={cloude3} alt="" className={styles.cloude3} />
                    </div>
                </div>
                <div className={styles.textSection}>
                    <div className={styles.textContainer}>
                        <img src={hipo} alt="Cute cartoon hippo holding blank scroll for message or story in kids animation scene" className={styles.hipo} />
                        <img src={hipophone} alt="Cute cartoon hippo holding blank scroll for message or story in kids animation scene" className={styles.hipophone} />

                        <h4 className={`font-brandon ${styles.hippotext}`}>
                            Moral stories <strong className={styles.strongtext}>designed to nurture</strong> <br />
                            emotional intelligence,  foster <br />
                            <strong className={styles.strongtext}>empathy</strong>, and support thoughtful <br />
                            decision-making in children <br />
                            <br />
                        </h4>
                        <h4 className={`font-brandon ${styles.hippotext2}`}>
                            <strong className={styles.strongtext}>Calmly paced </strong> narration <br />
                            (apx. 100-150 wpm) with <br />
                            minimal visual cuts, designed to <br />
                            <strong className={styles.strongtext}>improve intelligibility</strong>,<br />
                            comprehension, and listening <br />
                            <strong className={styles.strongtext}>comfort</strong> for young children <br />
                        </h4>
                        <h4 className={`font-brandon ${styles.hippotext3}`}>
                            Engaging, <strong className={styles.strongtext}>interactive</strong> content <br />
                            designed to hold attention <br />
                            without overstimulation
                        </h4>
                        <img src={cow} alt="Cute cartoon cow holding blank parchment scroll for story or message in kids animation scene" className={styles.cow} />
                        <img src={cowphone} alt="Cute cartoon cow holding blank parchment scroll for story or message in kids animation scene" className={styles.cowphone} />
                        <h4 className={`font-brandon ${styles.cowtext1}`}>
                            <strong className={styles.strongtext}>Fun</strong>, memorable  jingles to <br />
                            internalize <strong className={styles.strongtext}>positive values</strong> and <br />
                            improve <strong className={styles.strongtext}>motor skills</strong> <br />
                            through dance <br /> </h4>
                        <h4 className={`font-brandon ${styles.cowtext2}`}>
                            Encourages active play that <br />
                            supports <strong className={styles.strongtext}>healthy</strong> daily <strong className={styles.strongtext}>routines</strong>, <br />
                            <strong className={styles.strongtext}>better sleep</strong> patterns and <br />
                            improved <strong className={styles.strongtext}>emotional well-being</strong> <br /> </h4>
                        <h4 className={`font-brandon ${styles.cowtext3}`}>
                            <strong className={styles.strongtext}>Physical activity</strong> combined with <br />
                            active <strong className={styles.strongtext}>social interaction</strong> is <br />
                            associated with reduced <br />
                            symptoms of anxiety and <br />
                            depression</h4>
                        <img src={elephant} alt="Animated elephant host holding parchment scroll for important announcement in kids content" className={styles.elephant} />
                        <img src={elephantphone} alt="Animated elephant host holding parchment scroll for important announcement in kids content" className={styles.elephantphone} />

                        <h4 className={`font-brandon ${styles.elephanttext1}`}>
                            Thoughtfully designed <strong className={styles.strongtext}>interactive</strong> <br />
                            content that supports <strong className={styles.strongtext}>cognitive</strong> <br />
                            <strong className={styles.strongtext}>development</strong> and problem <br />
                            solving skills, while helping children <br />
                            explore <strong className={styles.strongtext}>real-world</strong> situations <br />
                        </h4>
                        <h4 className={`font-brandon ${styles.elephanttext2}`}>
                            Crafted in a <strong className={styles.strongtext}>game-show</strong> –style <br />
                            format that invites children <br />
                            to <strong className={styles.strongtext}>participate, choose</strong> <br />
                            responses, and stay actively <br />
                            engaged in the <strong className={styles.strongtext}>learning</strong> process <br />
                        </h4>
                        <h4 className={`font-brandon ${styles.elephanttext3}`}>
                            Interactions that gently teach <br />
                            both positive behaviours and <br />
                            behaviours to avoid—helping <br />
                            children understand social and <br />
                            moral norms</h4>
                        <img src={oak} alt="Wooden log signboard background with empty space for text in kids cartoon scene" className={styles.oak} />
                        <img src={mobileboard} alt="Wooden log signboard background with empty space for text in kids cartoon scene " className={styles.mobileboard} />

                        <h4 className={`font-brandon ${styles.oaktext1}`}>
                            Children need spaced-out repetitions <br className={styles.desktoponly} />
                            for <strong className={styles.strongtext}>enhanced learning</strong> and for <strong className={styles.strongtext}>improved</strong> recognition <strong className={styles.strongtext}>memory</strong> <br />
                        </h4>
                        <h4 className={`font-brandon ${styles.oaktext2}`}>
                            Combining visual, auditory, and interactive elements can support <strong className={styles.strongtext}>emotional</strong> <br className={styles.desktoponly} />
                            <strong className={styles.strongtext}>processing</strong> and <strong className={styles.strongtext}>improved learning</strong> outcomes in early childhood <br />
                        </h4>
                        <h4 className={`font-brandon ${styles.oaktext3}`}>
                            <strong className={styles.strongtext}>Guided by research</strong>, Jungle Morals, through jingles, stories, and interactive, aims to help children <br className={styles.desktoponly} />
                            understand emotions, <strong className={styles.strongtext}>build empathy,</strong> and feel more connected. Our approach focuses on <strong className={styles.strongtext}>positive values</strong> <br className={styles.desktoponly} />
                            and emotional tools that support <strong className={styles.strongtext}>children's well-being</strong> and social development.
                        </h4>
                        <h4 className={`font-adventuring ${styles.oaktext4}`}>
                            AND we have...
                        </h4>
                        <img src={activitycard} alt="Colorful light border banner with blank space for title or announcement in kids cartoon style" className={styles.activitycard} />
                        <h2 className={`font-adventuring ${styles.activitycardtitle}`}>Activity Cards</h2>

                        <div className={styles.imfo1Wrap}>
                            <img
                                src={info}
                                alt="Information icon"
                                className={`${styles.imfo1} ${styles.infoBtn}`}
                                role="button"
                                tabIndex={0}
                                ref={info1Ref}
                                onClick={(e) => togglePopover(e, sourceBanner1)}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner1) } }}
                            />
                        </div>
                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo2} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info2Ref}
                            onClick={(e) => togglePopover(e, sourceBanner2)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner2) } }} />

                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo3} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info3Ref}
                            onClick={(e) => togglePopover(e, sourceBanner3)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner3) } }} />

                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo4} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info4Ref}
                            onClick={(e) => togglePopover(e, sourceBanner4)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner4) } }} />

                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo5} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info5Ref}
                            onClick={(e) => togglePopover(e, sourceBanner5)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner5) } }} />

                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo6} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info6Ref}
                            onClick={(e) => togglePopover(e, sourceBanner6)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner6) } }} />

                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo7} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info7Ref}
                            onClick={(e) => togglePopover(e, sourceBanner7)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner7) } }} />

                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo8} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info8Ref}
                            onClick={(e) => togglePopover(e, sourceBanner8)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner8) } }} />

                        <img src={info}
                            alt="Information icon"
                            className={`${styles.imfo9} ${styles.infoBtn}`}
                            role="button"
                            tabIndex={0}
                            ref={info9Ref}
                            onClick={(e) => togglePopover(e, sourceBanner9)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner9) } }} />

                        <img src={info1}
                            alt="Information icon"
                            className={`${styles.imf10} ${styles.infoBtn} ${styles.desktopIcon}`}
                            role="button"
                            tabIndex={0}
                            ref={info10Ref}
                            onClick={(e) => togglePopover(e, sourceBanner10)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner10) } }} />

                        <img src={info}
                            alt="Information icon (mobile)"
                            className={`${styles.imf10} ${styles.infoBtn} ${styles.mobileIcon}`}
                            role="button"
                            tabIndex={0}
                            ref={info10MobileRef}
                            onClick={(e) => togglePopover(e, sourceBanner10)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner10) } }} />

                        <img src={info1}
                            alt="Information icon"
                            className={`${styles.imf11} ${styles.infoBtn} ${styles.desktopIcon}`}
                            role="button"
                            tabIndex={0}
                            ref={info11Ref}
                            onClick={(e) => togglePopover(e, sourceBanner11)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner11) } }} />

                        <img src={info}
                            alt="Information icon (mobie)"
                            className={`${styles.imf11} ${styles.infoBtn} ${styles.mobileIcon}`}
                            role="button"
                            tabIndex={0}
                            ref={info11MobileRef}
                            onClick={(e) => togglePopover(e, sourceBanner11)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { togglePopover(e, sourceBanner11) } }} />

                        <img
                            src={activity1}
                            alt="Kids activity card 'Super Hero' morning love theme with cartoon elephant and lion characters"
                            className={styles.activity1}
                            role='button'
                            tabIndex={0}
                            onClick={(e) => toggleCenteredGroup(e, [kids1, kids2], 'kids')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [kids1, kids2], 'kids'); } }}
                        />
                        <img
                            src={Mobileactivity1}
                            alt="Kids activity card ‘I’m Kind We’re Kind’ for parents with cartoon elephant and lion characters"
                            className={styles.activity1mobile}
                            role='button'
                            tabIndex={0}
                            onClick={(e) => toggleCenteredGroup(e, [kids1, kids2], 'kids')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [kids1, kids2], 'kids'); } }}
                        />

                        <h3 className={`font-adventuring ${styles.activitycardtitle1}`} >Empowering <br /> Children</h3>
                        <img
                            src={activity2}
                            alt="Kids activity card ‘Help Hop’ for teachers with cartoon elephant and lion promoting helping behavior"
                            className={styles.activity2}
                            role='button'
                            tabIndex={0}
                            onClick={(e) => toggleCenteredGroup(e, [teacher_1, teacher_2], 'teacher')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [teacher_1, teacher_2], 'teacher'); } }}
                        />

                        <img
                            src={Mobileactivity2}
                            alt="Kids super hero themed activity card with animal characters encouraging confidence"
                            className={styles.activity2mobile}
                            role='button'
                            tabIndex={0}
                            onClick={(e) => toggleCenteredGroup(e, [teacher_1, teacher_2], 'teacher')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [teacher_1, teacher_2], 'teacher'); } }}
                        />
                        <h3 className={`font-adventuring ${styles.activitycardtitle2}`} >Strengthening <br /> the Mind</h3>

                        <img src={activity3}
                            alt="Kindness activity card for kids with ‘I’m kind we’re kind’ message and cartoon elephant and lion"
                            className={styles.activity3}
                            role='button'
                            tabIndex={0}
                            onClick={(e) => toggleCenteredGroup(e, [parent1, parent2], 'parent')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [parent1, parent2], 'parent') } }}
                        />

                        <img
                            src={Mobileactivity3}
                            alt="Helping activity card for kids ‘Help Hop’ designed for teachers with cartoon elephant and lion characters"
                            className={styles.activity3mobile}
                            role='button'
                            tabIndex={0}
                            onClick={(e) => toggleCenteredGroup(e, [parent1, parent2], 'parent')}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { toggleCenteredGroup(e, [parent1, parent2], 'parent') } }}
                        />
                        <h3 className={`font-adventuring ${styles.activitycardtitle3}`} >Reconnecting with <br /> Roots</h3>

                    </div>
                    <div className={styles.textContent}>
                        <img src={elephantcrew} alt="Cartoon animals hugging showing friendship kindness and love in kids learning scene" className={styles.elephantcrew} />
                        <img src={chess} alt="Cartoon rabbit and dog playing chess showing thinking and problem solving for kids learning" className={styles.chess} />
                        <img src={dogs} alt="Cartoon parent and child showing love with message ‘parents are the best’ in kids learning scene" className={styles.dogs} />
                        <img src={infoboard} alt="Wooden banner with leaf decoration and empty space for title or text in kids cartoon scene" className={styles.infoboard} onClick={() => navigate('/form')} />
                        <h3 className={`font-adventuring ${styles.activitycardtitle4}`} onClick={() => navigate('/form')}>Grab your free activity card</h3>
                    </div>

                </div>
            </section>

            {popover.open && (
                <>
                    <div
                        className={popover.centered ? styles.backdropLayer : styles.backdropLayerLight}
                        onClick={closePopover}
                    />

                    <div
                        className={`${styles.popoverRoot} ${popover.centered ? styles.popoverRootCentered : ''}`}
                        style={popover.centered ? undefined : { top: popover.top, left: popover.left }}
                        role="dialog"
                        aria-modal={popover.centered ? 'true' : undefined}
                    >
                        <div className={styles.popoverCard} onClick={(e) => e.stopPropagation()}>
                            {popover.centered && Array.isArray(popover.imgs) && popover.imgs.length >= 2 ? (

                                <>
                                    {/* Close Button (X) - Top Left */}
                                    {/* <button
                                            onClick={closePopover}
                                            className={styles.closeButton}
                                            aria-label="Close"
                                        >
                                           ×
                                        </button> */}

                                    <button
                                        className={styles.closeButton}
                                        onClick={closePopover}
                                        aria-label="Close modal"
                                    >
                                        <svg
                                            width="36"
                                            height="36"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                        >
                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                        </svg>
                                    </button>



                                    <div className={styles.centeredModalContent}>
                                        {/* Close Button (X) - Top Right */}


                                        {/* Flip Card */}
                                        <div className={`${styles.flipCard} ${isFlipped ? styles.flipped : ''}`}>
                                            <div className={styles.flipInner}>
                                                {/* Front Side with YouTube Link */}
                                                <div
                                                    className={styles.flipFront}
                                                    onClick={(e) => handleImageClick(e, 'front')}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <img
                                                        src={popover.imgs[0]}
                                                        alt="Kids activity card morning love theme with cartoon elephant and lion characters"
                                                        className={styles.popoverImg}
                                                    />
                                                </div>
                                                {/* Back Side with YouTube Link */}
                                                <div
                                                    className={styles.flipBack}
                                                    onClick={(e) => handleImageClick(e, 'back')}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <img
                                                        src={popover.imgs[1]}
                                                        alt="activity-popover-back"
                                                        className={styles.popoverImg}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Flip Button - Below the card */}
                                        <div className={styles.flipButtonContainer}>
                                            <button
                                                onClick={handleFlip}
                                                className={`font-adventuring ${styles.flipButton}`}

                                            >
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    style={{ marginRight: '8px' }}
                                                >
                                                    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                                                </svg>
                                                Flip Card
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {/* {Array.isArray(popover.imgs) && popover.imgs.map((src, idx) => (
                                        <img key={idx} src={src} alt={`activity-popover-${idx + 1}`} className={styles.popoverImg} />
                                    ))} */}
                                    {popover.img && (
                                        <div className={styles.popoverImgWrap}>
                                            {anchorRef.current === info1Ref.current ? (
                                                <a
                                                    href="https://www.researchgate.net/publication/360882342_Children_for_integrity_The_influence_of_moral_stories_on_pre-schoolers%27_integrity_values"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info2Ref.current ? (
                                                <a
                                                    href="https://pubmed.ncbi.nlm.nih.gov/39680790/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info3Ref.current ? (
                                                <a
                                                    href="https://jamanetwork.com/journals/jamapediatrics/fullarticle/2812151"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info4Ref.current ? (
                                                <a
                                                    href="https://pubmed.ncbi.nlm.nih.gov/40219825/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info5Ref.current ? (
                                                <a
                                                    href="https://www.who.int/docs/default-source/physical-activity/information-sheet-global-recommendations-on-physical-activity-for-health/physical-activity-recommendations-5-17years.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info6Ref.current ? (
                                                <a
                                                    href="https://link.springer.com/article/10.1186/s12889-025-22690-8"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info7Ref.current ? (
                                                <a
                                                    href="https://publications.aap.org/pediatrics/article/140/Supplement_2/S57/34173/Digital-Screen-Media-and-Cognitive-Development"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info8Ref.current ? (
                                                <a
                                                    href="https://link.springer.com/article/10.1186/s40561-019-0085-2"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info9Ref.current ? (
                                                <a
                                                    href="https://www.sciencedirect.com/science/article/abs/pii/S002209652100240X"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info10Ref.current || anchorRef.current === info10MobileRef.current ? (
                                                <a
                                                    href="https://pubmed.ncbi.nlm.nih.gov/2017039/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : anchorRef.current === info11Ref.current || anchorRef.current === info11MobileRef.current ? (
                                                <a
                                                    href="https://www.researchgate.net/publication/341777573_Multimodal_Learning_Analytics_research_with_young_children_A_systematic_review"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                                </a>
                                            ) : (
                                                <img src={popover.img} alt="info-popover" className={styles.popoverImg} />
                                            )}
                                            {anchorRef.current === info1Ref.current && (
                                                <a
                                                    href="https://www.researchgate.net/publication/360882342_Children_for_integrity_The_influence_of_moral_stories_on_pre-schoolers%27_integrity_values"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay1}`}>
                                                        Source: Clinical Child Psychology  and Psychiatry Journal
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info2Ref.current && (
                                                <a
                                                    href="https://pubmed.ncbi.nlm.nih.gov/39680790/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay2}`}>
                                                        Source: Journal of Speech Language  and Hearing
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info3Ref.current && (
                                                <a
                                                    href="https://jamanetwork.com/journals/jamapediatrics/fullarticle/2812151"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay3}`}>
                                                        Source: Pediatrics Journal of
                                                        the American Medical Association
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info4Ref.current && (
                                                <a
                                                    href="https://pubmed.ncbi.nlm.nih.gov/40219825/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay4}`}>
                                                        Source: International Association of
                                                        Dance Medicine and Science
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info5Ref.current && (
                                                <a
                                                    href="https://www.who.int/docs/default-source/physical-activity/information-sheet-global-recommendations-on-physical-activity-for-health/physical-activity-recommendations-5-17years.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay5}`}>
                                                        Source: World Health
                                                        Organizations
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info6Ref.current && (
                                                <a
                                                    href="https://link.springer.com/article/10.1186/s12889-025-22690-8"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay6}`}>
                                                        Source: Scientific Review
                                                        by BioMed Central
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info7Ref.current && (
                                                <a
                                                    href="https://publications.aap.org/pediatrics/article/140/Supplement_2/S57/34173/Digital-Screen-Media-and-Cognitive-Development"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay7}`}>
                                                        Source: American Academy
                                                        of Pediatrics
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info8Ref.current && (
                                                <a
                                                    href="https://link.springer.com/article/10.1186/s40561-019-0085-2"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay8}`}>
                                                        Source: Smart Learning
                                                        Environments
                                                    </div>
                                                </a>
                                            )}
                                            {anchorRef.current === info9Ref.current && (
                                                <a
                                                    href="https://www.sciencedirect.com/science/article/abs/pii/S002209652100240X"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay9}`}>
                                                        Source: Journal of Experimental
                                                        Child Psychology
                                                    </div>
                                                </a>
                                            )}
                                            {(anchorRef.current === info10Ref.current || anchorRef.current === info10MobileRef.current) && (
                                                <a
                                                    href="https://pubmed.ncbi.nlm.nih.gov/2017039/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay10}`}>
                                                        Source: Journal of Experimental
                                                        Child Psychology
                                                    </div>
                                                </a>
                                            )}
                                            {(anchorRef.current === info11Ref.current || anchorRef.current === info11MobileRef.current) && (
                                                <a
                                                    href="https://www.researchgate.net/publication/341777573_Multimodal_Learning_Analytics_research_with_young_children_A_systematic_review"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.captionLink}
                                                >
                                                    <div className={`font-adventuring ${styles.captionOverlay11}`}>
                                                        Source: British Journal of
                                                        Educational Technology
                                                    </div>
                                                </a>
                                            )}
                                        </div>

                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </>
            )}


        </>
    );
}
export default Whatwedo;